import { render, staticRenderFns } from "./unlock.vue?vue&type=template&id=0a1f6b90&"
import script from "./unlock.vue?vue&type=script&lang=js&"
export * from "./unlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports